import styles from './InstallNudge.module.css'
import { useInstallPrompt } from './useInstallPrompt'

/**
 * §10.3 — required, not cosmetic.
 *
 * On iOS, durable storage depends on the site being installed to the home
 * screen: WebKit erases script-writable storage after roughly seven days
 * without interaction, and only home-screen-installed web apps are exempt. The
 * install prompt is therefore a **data-durability feature**. When it shows is
 * decided in `useInstallPrompt`.
 */
export function InstallNudge() {
  const { visible, canPrompt, install, dismiss } = useInstallPrompt()

  if (!visible) return null

  return (
    <aside className={`card ${styles.nudge}`}>
      <h2 className="card__title">Přidejte si Sciolingo na plochu</h2>
      <p className="muted">
        Nainstalovaná aplikace si spolehlivě pamatuje rozpracované úlohy a neodeslané odpovědi i v případě, že
        ji několik dní neotevřete.
      </p>

      {canPrompt ? (
        <button className="button button--primary" type="button" onClick={() => void install()}>
          Přidat na plochu
        </button>
      ) : (
        <p className="small">
          Na iPhonu: <strong>Sdílet</strong> → <strong>Přidat na plochu</strong>.
        </p>
      )}

      <button className="button button--quiet" type="button" onClick={() => void dismiss()}>
        Teď ne
      </button>
    </aside>
  )
}
